import { DUR_TONARTEN } from '../domain/tonarten'
import type { Tonart } from '../types'

interface Props {
  ausgewaehlt: Tonart | null
  highlightedDom?: Tonart | null
  highlightedSub?: Tonart | null
  onWaehle?: (tonart: Tonart) => void
  versteckt?: boolean
}

const RADIUS_AUSSEN = 160
const RADIUS_INNEN  = 100
const CENTER        = 200

export function Quintenzirkel({
  ausgewaehlt, highlightedDom, highlightedSub, onWaehle, versteckt,
}: Props) {
  if (versteckt) {
    return (
      <div className="kreis-versteckt">
        <p>Der Quintenzirkel ist versteckt — antworte aus dem Gedächtnis.</p>
      </div>
    )
  }

  return (
    <svg viewBox="0 0 400 400" className="quintenzirkel" role="img" aria-label="Quintenzirkel Dur">
      <circle cx={CENTER} cy={CENTER} r={RADIUS_AUSSEN + 18} fill="#f8f3e6" stroke="#dccfa3" />
      {DUR_TONARTEN.map((t) => {
        const winkel = (t.fifths * 30 - 90) * Math.PI / 180
        const xMid = CENTER + ((RADIUS_AUSSEN + RADIUS_INNEN) / 2) * Math.cos(winkel)
        const yMid = CENTER + ((RADIUS_AUSSEN + RADIUS_INNEN) / 2) * Math.sin(winkel)
        const istAusgewaehlt = ausgewaehlt?.name === t.name
        const istDom         = highlightedDom?.name === t.name
        const istSub         = highlightedSub?.name === t.name
        const fill = istAusgewaehlt ? '#8a4a3a'
                   : istDom         ? '#d4a23c'
                   : istSub         ? '#5a7e4b'
                   : '#fdfaf0'
        const text = istAusgewaehlt || istDom || istSub ? '#fff' : '#3a3a3a'
        return (
          <g key={t.name} onClick={() => onWaehle?.(t)} style={{ cursor: onWaehle ? 'pointer' : 'default' }}>
            <circle cx={xMid} cy={yMid} r={28} fill={fill} stroke="#bba47a" strokeWidth={1.5} />
            <text x={xMid} y={yMid + 5} textAnchor="middle" fill={text} fontSize={16} fontWeight="bold" pointerEvents="none">
              {t.name}
            </text>
            <text x={xMid} y={yMid + 22} textAnchor="middle" fill={text} fontSize={9} pointerEvents="none">
              {t.accidentals === 0 ? '' : t.accidentals + (t.accidentalType === 'sharp' ? '♯' : '♭')}
            </text>
          </g>
        )
      })}
      <circle cx={CENTER} cy={CENTER} r={RADIUS_INNEN - 30} fill="#fdfaf0" stroke="#dccfa3" />
      <text x={CENTER} y={CENTER - 4} textAnchor="middle" fontSize={14} fill="#7a6a4a">Quintenzirkel</text>
      <text x={CENTER} y={CENTER + 14} textAnchor="middle" fontSize={11} fill="#9a8a6a">Dur</text>
    </svg>
  )
}
